import { render, staticRenderFns } from "./wasteExchangeMainConfirm.vue?vue&type=template&id=67d20a4d&scoped=true"
import script from "./wasteExchangeMainConfirm.vue?vue&type=script&lang=js"
export * from "./wasteExchangeMainConfirm.vue?vue&type=script&lang=js"
import style0 from "./wasteExchangeMainConfirm.vue?vue&type=style&index=0&id=67d20a4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d20a4d",
  null
  
)

export default component.exports